import React, { useState } from "react";
import "./PujariSamagiri.scss";

// SVG assets
const imgCaretDown = "/assets/images/caret-down-pujari.svg";

const PujariSamagiri = ({ samagiriData = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Filter samagiri items where isProvidedBy is "pujari"
  const pujariSamagiriItems = samagiriData.filter(item => item.isProvidedBy === "pujari");

  // No need to calculate total amount since we're not showing prices

  // Format quantity with units
  const formatQuantity = (qty, units) => {
    if (units === "gms" || units === "ml") {
      return `${qty} ${units}`;
    } else if (units === "kgs") {
      return `${qty} ${units}`;
    } else {
      return `${qty}`;
    }
  };

  return (
    <div className="pujari-samagiri-container" data-node-id="8946:325">
      <div className="pujari-samagiri-content sm:tw-p-[24px]">
        <div className="pujari-samagiri-header" data-node-id="8946:326">
          <div className="pujari-samagiri-title" data-node-id="8946:327">
            <p>Samagiri provided by Pujari</p>
          </div>
          <div 
            className="pujari-samagiri-toggle" 
            onClick={() => setIsExpanded(!isExpanded)}
            data-name="CaretDown" 
            data-node-id="8946:328"
          >
            <div className={`caret-icon ${isExpanded ? 'expanded' : ''}`}>
              <img alt="" src={imgCaretDown} />
            </div>
          </div>
        </div>
        
        {isExpanded && (
          <div className="pujari-samagiri-content-area">
            {pujariSamagiriItems.length > 0 ? (
              <div className="pujari-samagiri-table">
                {/* Table Header */}
                <div className="table-header">
                  <div className="header-border" />
                  <div className="header-content">
                    <div className="description-header">
                      <div className="header-text">
                        <p>Item Description</p>
                      </div>
                    </div>
                    <div className="quantity-header">
                      <div className="header-text">
                        <p>Quantity</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Table Rows */}
                {pujariSamagiriItems.map((item, index) => (
                  <div key={item.id} className="table-row">
                    <div className={`row-border ${index === pujariSamagiriItems.length - 1 ? 'last-row' : ''}`} />
                    <div className="row-content">
                      <div className="description-cell">
                        <div className="item-text">
                          <p>{item.samagri?.name || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="quantity-cell">
                        <div className="quantity-text">
                          <p>{formatQuantity(item.qty, item.samagri?.units)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              </div>
            ) : (
              <p className="content-placeholder">No samagiri items provided by the pujari.</p>
            )}
          </div>
        )}
      </div>
      <div className="container-border" />
    </div>
  );
};

export default PujariSamagiri;
